var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackarrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3364 5.4526C10.6369 5.75467 10.6388 6.24632 10.3406 6.55075L7.83412 9.10987H14.2335C14.6569 9.10987 15 9.45753 15 9.88639C15 10.3152 14.6569 10.6629 14.2335 10.6629H7.83412L10.3406 13.222C10.6388 13.5264 10.6369 14.0181 10.3364 14.3202C10.0359 14.6222 9.5506 14.6203 9.25243 14.3159L5.44969 10.4333C5.15316 10.1306 5.15316 9.6422 5.44969 9.33945L9.25243 5.45687C9.5506 5.15245 10.0359 5.15053 10.3364 5.4526Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47901 4.52991 0 10.1136 0C15.6974 0 20.2273 4.47901 20.2273 10C20.2273 15.521 15.6974 20 10.1136 20C4.52991 20 0 15.521 0 10ZM10.1136 1.53846C5.38923 1.53846 1.55594 5.32868 1.55594 10C1.55594 14.6713 5.38923 18.4615 10.1136 18.4615C14.838 18.4615 18.6713 14.6713 18.6713 10C18.6713 5.32868 14.838 1.53846 10.1136 1.53846Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrowIcon);
export default __webpack_public_path__ + "static/media/backarrow_icon.1e28c0ce2605350fcf43a175ad5d23f8.svg";
export { ForwardRef as ReactComponent };